import React from 'react';
// @ts-ignore
import { Heading, Link, Loader, Button } from 'arag-ui-lib';
import CircleWrapper from '../general/circleWrapper/circleWrapper';
import ThumbUp from '../icons/thumbUp';
import styles from './surveyConfirmation.module.scss';
import { useTranslation } from 'react-i18next';

type Props = {
    context: {
        title: any;
        link: string;
        content: string;
        surveyTypes: Array<any>;
        posting: boolean;
        loading: boolean;
        error?: any;
    };
    navigateToNextSurvey?: () => void;
    surveyTypes?: Array<any>;
    hasUncompletedSurvey?: boolean;
};
const SurveyConfirmation = (props: Props): JSX.Element | null => {
    const { context, navigateToNextSurvey, hasUncompletedSurvey } = props;
    const { t } = useTranslation();
    if (
        !context ||
        context.posting ||
        context.loading ||
        hasUncompletedSurvey === null
    ) {
        return <Loader variant="inline" label={`${t('loading')}`} />;
    }

    return (
        <React.Fragment>
            <div className={'row'}>
                <div className={`col-sm-12 ${styles['container']}`}>
                    <div>
                        {!context?.error && (
                            <CircleWrapper>
                                <ThumbUp id={'thumpUp'} />
                            </CircleWrapper>
                        )}
                    </div>

                    <div>
                        <strong>{context?.title}</strong>
                    </div>
                    <div>
                        {context?.content}
                        {context?.link && (
                            <a
                                href={context.link}
                                className={styles['link']}
                                target="_blank"
                            >
                                link
                            </a>
                        )}
                    </div>
                </div>
            </div>
            {hasUncompletedSurvey ? (
                <div className={`container row ${styles['primary-button']}`}>
                    <div className={'col-sm-1 col-sm-offset-9'}>
                        <Button
                            variant="primary"
                            label={`${t('continueToNextSurvey')}`}
                            arrowDirection="right"
                            onClick={navigateToNextSurvey}
                            disabled={context?.loading || !hasUncompletedSurvey}
                        />
                    </div>
                </div>
            ) : null}
        </React.Fragment>
    );
};

export default SurveyConfirmation;
